import React from 'react';
import { Title } from '@/components/atoms/Title';
import { SavingBar } from '@/components/atoms/SavingBar';
import Loader from '@/components/atoms/Loader';
import NavigationTabs from '@/components/organisms/RouterNavigationTabs';
import { routes } from '@/core/router/routes';
import { Container, Content, TitleContainer } from './Info.style';
import { EwalletOverdraftSection } from './EwalletOverdraftSection';
import useInfoVM from './Info.viewmodel';

const Info: React.FunctionComponent = () => {
    const {
        isLoading,
        isSaving,
        useEwalletOverdraft,
        ewalletOverdraftAmount,
        postPaymentCustomersCount,
        canDisableOverdraft,
        changesCount,
        handleToggleOverdraft,
        handleAmountChange,
        handleSave,
        handleCancel,
    } = useInfoVM();

    const tabRoutes = React.useMemo(() => routes.filter(({ tab }) => tab === 'brands'), []);

    return (
        <>
            <NavigationTabs routes={tabRoutes}>
                <Container>
                    <TitleContainer>
                        <Title text="brandInfo.title" />
                    </TitleContainer>
                    <Content>
                        {isLoading ? (
                            <Loader withContainer />
                        ) : (
                            <EwalletOverdraftSection
                                useEwalletOverdraft={useEwalletOverdraft}
                                ewalletOverdraftAmount={ewalletOverdraftAmount}
                                postPaymentCustomersCount={postPaymentCustomersCount}
                                canDisableOverdraft={canDisableOverdraft}
                                onToggleOverdraft={handleToggleOverdraft}
                                onAmountChange={handleAmountChange}
                            />
                        )}
                    </Content>
                </Container>
            </NavigationTabs>
            <SavingBar onSave={handleSave} changesCount={changesCount} onCancel={handleCancel} loading={isSaving} />
        </>
    );
};

export default Info;
